/**
 * The identity of the bundle that is running.
 *
 * `__APP_VERSION__` is the package version; `__BUILD_ID__` distinguishes two
 * builds that carry the same package version, which is the normal case during
 * a deploy. Both are inlined at build time (see `vite.config.ts`).
 *
 * The `typeof` guards matter: these globals exist in a Vite build but not in
 * the test runner or in any other bundler that happens to import this module,
 * and a bare reference would throw a `ReferenceError` there.
 */

/** Package version, e.g. `0.1.0`. */
export const APP_VERSION: string = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : '0.0.0';

/** Build revision, e.g. a commit SHA or a compact build timestamp. */
export const BUILD_ID: string = typeof __BUILD_ID__ === 'string' ? __BUILD_ID__ : 'dev';

/**
 * Short form of the build id, for places where the full revision does not fit.
 *
 * A commit SHA is already short and is returned whole; a long value is
 * truncated rather than wrapped so a heading never reflows.
 */
export function shortBuildId(buildId: string = BUILD_ID): string {
  return buildId.length > 16 ? `${buildId.slice(0, 16)}…` : buildId;
}
